import { css, StyleSheet } from 'aphrodite/no-important'
import { familyPriceTableMonthly } from '@lmc/common/constants/pricingTables'
import { FamilyPaymentOption } from '../../../../screens/AccountsSettings/FamilySettings/components'

interface FamilyPortalPaymentOptionsProps {
  activeResidents: number
  fields: any
  formId: string
  setFormField: (args: { key: string; value: any }) => void
}

export default function FamilyPortalPaymentOptions({
  activeResidents,
  fields,
  formId,
  setFormField,
}: FamilyPortalPaymentOptionsProps) {
  const homeSelected = fields.familyPaymentType === 'home'

  return (
    <div className={css(classes.paymentOptionsContainer)}>
      <FamilyPaymentOption
        payee="Care Service billed monthly"
        // @ts-ignore
        costPerMonth={familyPriceTableMonthly[activeResidents]}
        activeResidents={activeResidents}
        imgUrl="https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/family/nursing-home-free-trial.png"
        mainText="The price is based on the number of active clients in your service."
        bulletPoint1="Offer as a benefit to as many families as you like"
        bulletPoint2="Demonstrate outstanding innovation and family involvement"
        bulletPoint3="Families don't need to pay"
        fields={fields}
        formId={formId}
        option={{ value: 'home', label: 'Care Service' }}
        onClick={() =>
          setFormField({ key: 'familyPaymentType', value: 'home' })
        }
        isActive={homeSelected}
      />
    </div>
  )
}

const classes = StyleSheet.create({
  paymentOptionsContainer: {
    padding: '32px 0 50px 0',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
})
